import React from "react";

export const preloadImage = (src) => {
    const image = new Image();
    image.src = src;
};

// Static banners definition
const staticBanners = [
  {
    url: "../../assets/Banners/banner2.jpeg", // Make sure the path is correct and reachable
    heading: "Welcome to Motor Easy",
    paragraph: "Ensuring your vehicle's reliability and performance.",
    actionLabel: "Learn More"
  },
  {
    url: "../../assets/Banners/home-3.jpg",
    heading: "Comprehensive Car Care",
    paragraph: "Complete solutions from inspections to repairs.",
    actionLabel: "Contact Us"
  }
];

// Preload static banner images
staticBanners.forEach(banner => preloadImage(banner.url));